/**
 * The partner category will be passed from the parameters
 */
const SERVER_URL = "/api/v2/products/:partnerCategory";

export default {
  //partner management
  getPartnerProductList: {
    method: "get",
    url: `${SERVER_URL}/internal/products/partner/list`,
  },
  getPartnerProductDetail: {
    method: "get",
    url: `${SERVER_URL}/internal/products/partner/detail/:id`,
  },
  addPartnerProduct: {
    method: "post",
    url: `${SERVER_URL}/products/partner`,
  },
  updatePartnerProduct: {
    method: "patch",
    url: `${SERVER_URL}/internal/products/partner/:product_code`,
  },
  deletePartnerProduct: {
    method: "delete",
    url: `${SERVER_URL}/internal/products/partner/:product_code`,
  },
};
